import styled from "styled-components"

import { COLOR } from 'ggx-componentlibrary/design/color/color.constants'
import { SPACING } from "ggx-componentlibrary/design/spacing/spacing.constants"
import OrderDetailCross from "./assets/order-detail-cross.svg"
import BET_3668 from 'ggx-src/feat/BET_3668'

const ORDER_DETAIL_WIDTH = 370

const StyledOrderDetailCross = styled(OrderDetailCross)`
  cursor: pointer;
  background: none;
  -webkit-appearance: none;
`

const LoaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`

const StyledContainer = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${SPACING.M};
  ${BET_3668.adjustment.containerStyle}
`

const StyledHR = styled.hr`
  border: none;
  border-top: 1px solid ${COLOR.GREY_LIGHT};
  margin: 0;
`

const AdaptiveContainer = styled.div`
  display: grid;
  grid-template-columns: ${props => !props.$sm ? '1fr 1fr': '100%'};
  gap: 32px;
`

const TipPanel = styled.div`
  padding: 12px 16px;
  background-color: ${COLOR.GREY_LIGHTEST};
  width: 100%;
  border-radius: 6px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
`

export {
  ORDER_DETAIL_WIDTH,
  StyledOrderDetailCross,
  LoaderWrapper,
  StyledContainer,
  StyledHR,
  AdaptiveContainer,
  TipPanel,
}
